<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" class="pa-2">
        <div class="pa-1 bordered rounded bg-grey_3" v-if="list_inscriptions.length > 0">
          <v-sheet color="darkblue text-h6 pa-2">Total: {{ total_pointes }}/{{ total_valides }} inscrits
            pointés</v-sheet>

          <div class="pa-1 my-2 bg-white bordered rounded" v-for="course in inscriptions_by_races" :key="course.id">
            <div class="text-body-1 font-weight-bold">
              <span v-if="course.infos.nom">{{ course.infos.nom }}</span><span v-else>Inscription non sportive</span>
            </div>
            <div class="text-body-2">
              <div class="d-flex sm-gap mb-2">
                <v-chip color="darkblue" size="large" density="compact" variant="elevated" elevation="0">{{
                  course.nb_pointes }}/{{ course.runners.length }} pointés</v-chip>
              </div>
              <v-progress-linear rounded :model-value="get_progress(course.nb_pointes, course.runners.length)"
                color="darkblue" height="6"></v-progress-linear>
            </div>
          </div>
        </div>
      </v-col>
      <!-- <v-col cols="12" md="6" class="pa-2">
        <div class="pa-1 bordered rounded bg-grey_3" v-if="list_inscriptions.length > 0">
          <v-sheet color="darkblue text-h6 pa-2">Les participants en attente</v-sheet>
          <div class="pa-1 my-2 bg-white bordered rounded" v-for="course in inscriptions_by_races_pendings" :key="course.id">
            <div class="text-body-1 font-weight-bold">
              <span v-if="course.infos.nom">{{ course.infos.nom }}</span
              ><span v-else>Inscription non sportive</span>
            </div>
            <div class="d-flex sm-gap mb-2 flex-wrap" v-if="course.runners.length > 0">
              <v-chip v-for="runner in course.runners" :key="runner.id">{{ runner.nom }} {{ runner.prenom }}</v-chip>
            </div>
            <p v-else>Tous les participants ont été accueillis</p>
          </div>
        </div>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service.js";
export default {
  data() {
    return {
      list_inscriptions: [],
    };
  },
  methods: {
    async fetch() {
      let res = await AdminService.getPointageAccueil(this.mainStore.module.id);
      if (res) {
        this.list_inscriptions = res;
      }
    },
    get_progress(nb, max_inscrits, replace_max = null) {
      if (nb == 0) return 0;
      if (max_inscrits == 0) {
        if (replace_max) return (nb * 100) / replace_max;
        return 100;
      }
      return (nb / max_inscrits) * 100;
    },
  },
  computed: {
    ...mapStores(useMainStore),
    total_pointes() {
      let total = 0;
      for (let course_id in this.inscriptions_by_races) {
        total += this.inscriptions_by_races[course_id].nb_pointes;
      }
      return total;
    },
    total_valides() {
      let total = 0;


      for (let course_id in this.inscriptions_by_races) {
        total += this.inscriptions_by_races[course_id].runners.length;
      }

      return total;
    },
    inscriptions_by_races() {
      if (this.list_inscriptions.length === 0) return [];
      // Use reduce to group runners by id_course
      const groupedByCourse = this.list_inscriptions.reduce((acc, runner) => {
        // Check if id_course already exists in accumulator
        if (acc[runner.id_course]) {
          // If it exists, push the runner to the existing array
          acc[runner.id_course].runners.push(runner);
          if (runner.commande_inscription.pointe == "1") {
            acc[runner.id_course].nb_pointes++;
          } else {
            acc[runner.id_course].nb_missing++;
          }
        } else {
          // If it doesn't exist, create a new array with the runner
          acc[runner.id_course] = { runners: [runner], infos: runner.course, nb_pointes: 0, nb_missing: 0 };
          if (runner.commande_inscription.pointe == "1") {
            acc[runner.id_course].nb_pointes++;
          } else {
            acc[runner.id_course].nb_missing++;
          }
        }
        return acc;
      }, {});

      // Convert the grouped object to an array (if needed)

      return groupedByCourse;
    },
    inscriptions_by_races_pendings() {
      if (this.list_inscriptions.length === 0) return [];
      // Use reduce to group runners by id_course
      const groupedByCourse = this.list_inscriptions.reduce((acc, runner) => {
        if (runner.commande_inscription.pointe == "0") {
          // Check if id_course already exists in accumulator

          if (acc[runner.id_course]) {
            // If it exists, push the runner to the existing array

            if (acc[runner.id_course].runners.length < 6) {
              acc[runner.id_course].runners.push(runner);
            } else {
              if (acc[runner.id_course].runners.length == 6) {
                acc[runner.id_course].runners.push({ nom: "", prenom: "..." });
              }
            }
          } else {
            // If it doesn't exist, create a new array with the runner

            acc[runner.id_course] = { runners: [runner], infos: runner.course };
          }
        }

        return acc;
      }, {});

      // Convert the grouped object to an array (if needed)

      return groupedByCourse;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>

<style lang="scss" scoped></style>